export default "__VITE_ASSET__C0Dhn7e0__"